import { memo } from 'react';

import { getStars } from '../utils/get-stars';
import getIcon from '../../icons';

function makeArrayStars(length, iconId) {
  return Array.from({ length }, (_, i) => getIcon({ iconId, key: `${iconId}-${i}` }));
}

/**
 * Renders stars based on the provided rating and stars object.
 * @param {Object} props - The component props.
 * @param {Object} props.stars - The stars object containing star values.
 * @param {number} props.rating - The rating value.
 * @returns {Array} An array of star elements.
 */

const RenderStars = ({ stars, rating }) => {
  const arrayStart = getStars(stars?.value ? stars?.value : rating);

  const structure = arrayStart.map((star, index) => {
    const { iconId, count } = star;

    return makeArrayStars(count, iconId, index);
  });

  return structure.flat();
};

const MemoizedRenderStars = memo(RenderStars);

export default MemoizedRenderStars;
